import { format } from "date-fns"
import Image from "next/image"
import Link from "next/link"
import type { PostMeta } from "@/lib/content"

const BlogLayoutThree = ({ blog }: { blog: PostMeta }) => {
  return (
    <div className="group w-full h-full flex flex-col items-center bg-dark3 hover:bg-dark2 border-2 border-light/5 p-4 rounded-2xl">
      {
        blog.image &&
        <Link href={blog.url} className="w-full h-full max-h-64 md:h-52 rounded-xl overflow-hidden">
          <Image
            src={blog.image.src}
            placeholder="blur"
            blurDataURL={blog.image.blurDataURL}
            title={blog.title}
            alt={`Cover Image of ${blog.title}`}
            width={blog.image.width}
            height={blog.image.height}
            className="aspect-[4/5] shadow-md w-full min-w-72 h-full object-cover object-center group-hover:scale-105 transition-all ease duration-300"
            sizes="(max-width: 640px) 100vw,(max-width: 1024px) 50vw, 33vw"
          />
        </Link>
      }

      <div className="flex flex-col w-full mt-4">
        {
          blog.tags && blog.tags.length > 0 &&
          <span className="uppercase text-accent font-semibold text-xs sm:text-sm">
            {blog.tags[0]}
          </span>
        }
        <Link href={blog.url} className="inline-block my-1">
          <h2 className="font-semibold capitalize text-base sm:text-lg">
            <span
              className="blog-title"
            >
              {blog.title}
            </span>
          </h2>
        </Link>

        <span className="capitalize text-light/60 font-semibold text-xs sm:text-sm">
          {format(new Date(blog.publishedAt), "MMMM dd, yyyy")}
        </span>
      </div>
    </div>
  );
};

export default BlogLayoutThree;
